export default __webpack_public_path__ + "static/media/our-services-edu-further-education-banner.ef536805.jpg";